module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("2")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "font"
  }, [_vm._v("I "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WRESTLE AROUND IN THE")])]), _vm._v(" scratchy sheets, wrinkled from too much time in a cardboard moving box. Light is streaming in through the window and I drape an arm over my eyes, shielding them. How can they sell a house without curtains? I mean, isn’t that sort of like selling cake with no icing?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sitting up, I lean over the edge of my bed and groan as two of my pastels come into view. The blue and the magenta. My favorite colors in the entire set are sitting on my floor, exactly where they shouldn’t be. I glance at the open pastel box across the room. How did these colors get way over here?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("I rub my bleary eyes and collect the pastels from the floor, vaguely remembering that I had a ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("nightmare last night. There was howling out in the hallway. Or maybe it was crying. I’m not sure now, but just thinking about it makes all the hair on my arms prickle.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tess?” Mom’s voice filters through my door as I snatch the pastels up, checking to make sure their fragile tips aren’t broken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Breakfast is on the table. I have to go to the grocery store; we need actual food in here eventually,” she says with a chuckle, and I clutch my grumbly stomach. We’ve been in this place almost two full days already and I haven’t eaten anything that didn’t come out of a bag.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay. Dad’s here, right?” I yell back, padding across the chilly wood floor to the sketchpad that’s lying on my desk. Funny how all my clothes are still in boxes and not one permanent decoration is up, but all my art supplies have been unpacked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I can’t help it; I need them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The door slides open a crack, and Mom’s face peeks in. “Sorry, honey, I just didn’t want to yell. I’m not up for waking Jonah yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I check the clock. Eight fifteen. “Why is Jonah still asleep? He’s usually up at the butt-crack of dawn!”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Mom shoots me a dirty look, and I shrug an ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("apology. She’s always hated that phrase, even though Dad and I think it’s hilarious.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“He didn’t sleep well last night. Honestly, I don’t know what to call the dreams he was having . . . night terrors, I suppose.” She looks thoughtful for a moment before continuing. “Such a brave boy for only four years old. I’m sure this move has been hard on him.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Night terrors. Poor guy. As annoying as he can be with that creepy little doll of his, I don’t like to think of him having bad dreams. And night terrors sound worse than bad dreams.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“So, Dad’s here and Jonah’s in bed. Got it,” I say, edging closer to my sketchpad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom stares at me pointedly. “Tessa. You start seventh grade at your new school tomorrow. Don’t you think you need to unpack bit more? Start settling in?” She folds her arms over her chest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I have no interest in settling into this place. It’s dark. It smells like old people and every single corner has a spider in it. No thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I will. I just need a few days.” And a one-way ticket back home. I miss the sound of waves and the smell of the salt hanging in the air. I miss lizards and sand between my toes. I miss Rachel.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("Rachel is the peanut butter to my jelly. The sour ")]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("cream to my onion. The sugar to my lemonade. She’s my best friend, and I had to leave her behind. It’s wrong. It’s so, so wrong.")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I reach up to my collarbone and rub the small silver locket between my fingers. It’s the only thing connecting me to her now . . . the only thing we share. Rachel’s is strung on black leather instead of a chain, and the picture inside is of me; otherwise they’re identical.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom crosses the space between us and pulls me in for a hug. She smells like lavender. Tilting my chin up, she smiles and the little mole to the right of her mouth winks at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is going to get easier, honey. I promise. I’ll make a space for myself to paint here, and you’ll keep drawing. We’re artists. Creators of our own destiny!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Brushing the hair off my forehead, she kisses the top of my head. I wish I could believe all that, but I don’t. Not when I have to walk through the doors of a completely new school tomorrow. Make new friends and find my way down new streets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom pulls away, then hovers by my door for a minute. “There’s beauty in this place, Tess. You just have to look for it.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“I’ll try,” I say, mostly because I trust her. Mom and I have always seen eye to eye on things, probably ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("because we’re both artists. She sees the world in sea-glass colors, and I love her for it.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The door clicks shut behind her, and I grab a pair of jeans off the chair I slung them over last night. My sketchpad is open just slightly and I stop in my tracks, confused at the small blur I can see in the upper left-hand corner of the sheet. It’s grayish black, like I started something and then just barely ran the pad of my thumb over it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What in the—” I start, bending closer to the page.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t draw anything last night. I was so tired from carrying boxes all over this ginormous place that I crawled into bed without even brushing my teeth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stare at the mark. It’s small and shaped like an upside-down "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("L")]), _vm._v(". Lifting the book and giving the paper a tap, I watch as the unwelcome spot becomes dust again and drifts into the air. There will still be a darkened area there, but I’ll camouflage it with shading later. Still. There’s something about that mark that bothers me. Something off.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shutting the pad, I pull open my desk drawer and drop it in. Mom and Dad bought me this desk specifically for art, and it has a drawer that’s wider than most. It’s deep, too, plenty deep enough to hold several boxes of pastels.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("The vibrations of Dad’s violin begin to ring through my walls, and I can’t help but smile. Even though it brought us here and has ruined "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("everything")]), _vm._v(" I was looking forward to, I still love that sound. It reminds me of sunset nights, of grouper on the grill, and of cold iced tea.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It reminds me of home.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 63
// module chunks = 0